import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a partner field in the charge list with a link to the partner's detail page
 * Uses the embedded partner object from the charge API response
 */
const ChargePartnerField: React.FC<FieldProps<any>> = ({
    record,
    link = 'show',
}) => {
    if (!record) return null;

    // Handle both nested partner object and direct partnerId
    const partner = record.partner;
    const partnerId = partner?.id || record.partnerId;
    const partnerName = partner?.name;

    if (!partnerId) return <span>-</span>;
    if (!partnerName) return <span>{partnerId}</span>;

    return link ? (
        <Link to={`/partners/${partnerId}/show`}>{partnerName}</Link>
    ) : (
        <span>{partnerName}</span>
    );
};

ChargePartnerField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

ChargePartnerField.defaultProps = {
    addLabel: true,
    label: 'Partner',
};

export default ChargePartnerField;
